module.exports = __webpack_public_path__ + "media/images/pla/pla22-ccd11f2d82c9d45c907dac7d1b036516.jpg";